import { useSession } from "providers/SessionProvider";
import { useEffect } from "react";

export const usePageTitle = (title?: string) => {
    const session = useSession();

    useEffect(() => {
        document.title = session.config.tenantUIConfig.title + (title ? " - " + title : "");
    }, []);

    return true;
};
